import React from "react";
import styled from "styled-components";
import colors from "../../../styles/colors";
import fonts from "../../../styles/fonts";

const Wrapper = styled.div`
  /* height: 400px; */
  width: 338px;
  font-weight: 400;

  @media screen and (max-width: 380px) {
    width: 300px;
  }

  @media screen and (max-width: 340px) {
    width: 260px;
  }

  > form {
    padding: 10px;

    > h2 {
      font-size: 17.6px;
      margin-bottom: 20px !important;
      margin-top: 0px !important;
      text-align: center;
    }

    > p {
      font-size: 13px !important;

      margin-top: 15px !important;
      margin-bottom: 0px !important;
      text-align: left;

      > label {
        color: ${colors.accent};
        font-family: ${fonts.header};
        letter-spacing: 0.09em;
        text-transform: uppercase;
        width: 100%;
      }

      > .input {
        border: 1px solid ${colors.border};
        font-family: ${fonts.main};
        font-size: 16px;
        margin-bottom: 5px;
        margin-top: 5px;
        padding: 4px 7px;
        max-width: 100%;
        width: 100%;
      }

      > .textarea {
        height: 75px;
        max-height: 75px;
      }
    }

    > .submit {
      background-color: white;
      border: 1px solid #8cd0c5;
      border-radius: 3px;
      color: #8cd0c5;
      cursor: pointer;
      display: inline-block;
      font-family: ${fonts.header};
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 1px;
      margin-left: 50%;
      margin-top: 15px;
      padding: 5px 8px;
      position: relative;
      text-transform: uppercase;
      transform: translateX(-50%);
      transition: all 0.4s ease;

      &:hover {
        background-color: rgba(140, 208, 197, 0.2);
      }
    }
  }
`;

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

export default class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      message: "",
      submitted: false
    };
  }

  /* Here’s the juicy bit for posting the form submission */

  handleSubmit = e => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...this.state })
    })
      .then(() => this.setState({ submitted: true }))
      .catch(error => alert(error));

    e.preventDefault();
  };

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  render() {
    const { name, email, message, submitted } = this.state;
    return (
      <Wrapper>
        {submitted ? (
          <div>
            {" "}
            <h2>Bedankt</h2>
            <p>Bedankt voor je feedback!</p>
            <img
              src="/img/heres-to-you.gif"
              style={{ marginBottom: "-8px", width: "100%" }}
            />
          </div>
        ) : (
          <form
            name="contact"
            netlify-honeypot="bot-field"
            onSubmit={this.handleSubmit}
          >
            <h2>Feedback</h2>
            <p>
              Ben je een fout tegengekomen? Vind je een uitleg onduidelijk? Heb
              je andere tips? Laat het me weten!
            </p>
            <p className="hidden">
              <label>
                Don’t fill this out if you're human: <input name="bot-field" />
              </label>
            </p>
            <p>
              <label>Naam*</label>{" "}
              <input
                className="input"
                type="text"
                name="name"
                value={name}
                onChange={this.handleChange}
                autoFocus
                required
              />
            </p>

            <p>
              <label>Emailadres*</label>{" "}
              <input
                className="input"
                type="text"
                name="email"
                value={email}
                onChange={this.handleChange}
                required
              />
            </p>

            <p>
              <label>Feedback*</label>{" "}
              <textarea
                className="input"
                name="message"
                value={message}
                onChange={this.handleChange}
                required
              />
            </p>

            <input type="hidden" name="form-name" value="contact" />

            <button type="submit" className="submit">
              Verzenden
            </button>
          </form>
        )}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/feedback/Form.js